export default "__VITE_ASSET__Y4YXJYK1__"